import { atom } from 'recoil';

export const searchTargetNameState = atom<string|null>({
  key: 'searchTargetNameState',
  default: null,
});


